import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-left-medium, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleLeftMedium"><path d="M7.22559 12L15 18.5781V5.42188L7.22559 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleLeftMedium;
